export default class Booking {
  constructor() {
    this.bookingContainers = document.querySelectorAll(
      '[data-booking-container]',
    );
    if (!this.bookingContainers.length) return;

    this.handleClose();
  }

  handleClose() {
    this.bookingContainers.forEach((container) => {
      const bookings = container.querySelectorAll('[data-booking-item]');
      bookings.forEach((booking) => {
        const close = booking.querySelector('[data-booking-close]');

        close.addEventListener('click', () => {
          const entry = close.parentElement.parentElement;
          const id = entry.getAttribute('data-booking-item');

          const bookingInput = document.querySelector('#training_register_container form [name="tx_exteducationbooking_trainings[trainingIds]"]');

          let values = bookingInput.value.split(',');
          values = values.filter((value) => {
            return value != id;
          });
          bookingInput.value = values;

          entry.remove();

          if (container.querySelectorAll('[data-booking-item]').length <= 0) {
            window.location.href = "/bildung";
          }
        });
      });
    });
  }
}
